// extracted by mini-css-extract-plugin
module.exports = {"host":"distributor-form-company_host_3ji2y","label":"distributor-form-company_label_2O_2M","button":"distributor-form-company_button_WqWOE"};